import orderBy from 'lodash/orderBy';
import { createNamespacedHelpers } from 'vuex';
import IconArrow from '@/assets/icons/arrow.svg';

import ChannelItem from '@/components/channel_item/ChannelItem.vue';

import ChannelDefs from '@/store/channel/channel.d';
import LayoutDefs from '@/store/layout/layout.d';
import subscription from '@/api/subscription';

const { mapState: mapChannelState, mapActions: mapChannelActions } =
  createNamespacedHelpers('Channel');
const { mapActions: mapLayoutActions } = createNamespacedHelpers('Layout');

export default {
  name: 'ConciergeItem',
  components: {
    IconArrow,
    ChannelItem
  },
  props: {
    concierge: {
      conciergeId: String,
      name: String,
      languages: [String],
      profilePhoto: String,
      channels: [Object]
    },
    isTransferModal: Boolean
  },
  data: function () {
    return {
      premiumRecords: {},
      isChannelListShown: false
    };
  },
  computed: {
    ...mapChannelState({
      getCurrentChannelURL: function (state) {
        return state.currentChannel ? state.currentChannel.channelUrl : '';
      }
    })
  },
  watch: {
    isChannelListShown() {
      if (!this.isChannelListShown) return;

      const userIds = this.concierge.channels.map(
        (channel) => channel.sender.user_id
      );
      subscription.getSubscriptionByUsers(userIds).then((response) => {
        this.premiumRecords = Object.assign(
          {},
          this.premiumRecords,
          response || {}
        );
      });
    }
  },
  methods: {
    ...mapChannelActions({
      channelStore_transferChannel: ChannelDefs.actions.transferChannel,
      channelStore_setOwnChannels: ChannelDefs.actions.setOwnChannels,
      channelStore_joinChannel: ChannelDefs.actions.joinChannel
    }),

    ...mapLayoutActions({
      layoutStore_closeModal: LayoutDefs.actions.closeModal
    }),

    transferChannel: async function (conciergeId) {
      await this.channelStore_transferChannel({ conciergeId });
      this.layoutStore_closeModal({ module: 'transfer' });
    },

    toggleConciergeChannelList: function () {
      this.isChannelListShown = !this.isChannelListShown;
    },

    orderedChannels: function () {
      if (!this.concierge.channels) return [];
      if (this.concierge.channels.length === 0) return [];

      this.concierge.channels.forEach((channel) => {
        if (channel.rewards && channel.rewards.length) {
          channel.totalRewards = channel.rewards
            .map((reward) => reward.rewardCount)
            .reduce((totalRewards, value) => {
              return totalRewards + value;
            });
        }
      });

      return orderBy(this.concierge.channels, [
        (concierge) => -concierge.totalRewards,
        (concierge) => concierge.last_message_activity
      ]);
    }
  }
};
